"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessages = exports.ProgressMessages = exports.ProgressTitles = void 0;
const localizeUtils_1 = require("../common/localizeUtils");
class ProgressTitles {
    static create = (0, localizeUtils_1.getLocalizedString)("core.progress.create");
}
exports.ProgressTitles = ProgressTitles;
class ProgressMessages {
    static generateTemplate = (0, localizeUtils_1.getLocalizedString)("core.progress.createFromTemplate");
    static generateSample = (sampleName) => (0, localizeUtils_1.getLocalizedString)("core.progress.createFromSample", sampleName);
    static configureAzureStorageEnableStaticWebsite = (0, localizeUtils_1.getLocalizedString)("core.progress.configureAzureStorage");
    static runCommand = (command, directory) => (0, localizeUtils_1.getLocalizedString)("core.progress.runCommand", command, directory);
    static deployToAzure = (location, dist) => (0, localizeUtils_1.getLocalizedString)("core.progress.deployToAzure", location, dist);
}
exports.ProgressMessages = ProgressMessages;
class LogMessages {
    static getTemplateFromLocal = (0, localizeUtils_1.getLocalizedString)("plugins.function.getTemplateFromLocal");
}
exports.LogMessages = LogMessages;
//# sourceMappingURL=messages.js.map